import { TenantConfigurationControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

interface Params {
  configuration: any;
  xTENANTID?: string;
}

/**
 * @author Shrinivas Mandhare
 */
export const useUpdateTenantConfiguration = () =>
  useMutationWithLoading(async (params: Params) =>
    new TenantConfigurationControllerApi(
      getConfigObject()
    ).updateTenantConfiguration(params.configuration, params.xTENANTID)
  );
